import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="specific--dossier"
export default class extends Controller {
  static targets = ["header"]
  static values = { zugriffUrl: String }

  umschalten() {
    const aktiv = this.element.classList.toggle("dossier--aktiv")
    this.headerTarget.setAttribute("aria-expanded", aktiv)

    if (aktiv) {
      this.zugriffProtokollieren()
    }
  }

  zugriffProtokollieren() {
    if (this.protokolliert) return

    this.protokolliert = true
    fetch(this.zugriffUrlValue)
  }
}
